import config from "../../../../config";
import { CfgColors } from "core/config";

import { deleteCanvasPhase } from "./update";

const colourCfg = config.get(CfgColors);

export const clickCanvasPhaseContextMenuAction = (
	playgroundProps, canvas, phase
) => {
	return (e) => {
		const { dashboard, openEditPhase, updateCanvas, openConfirm, showContextMenu } = playgroundProps;

		e.preventDefault();

		showContextMenu({
			actions: [{
				label: "Edit",
				icon: "fad fa-edit",
				onClick: () => {
					openEditPhase({ phase: phase, canvas: canvas });
				}
			}, {
				label: "Delete Condition",
				icon: "fad fa-trash",
				onClick: () => {
					openConfirm({
						title: "Delete Condition?",
						confirmLabel: "Delete",
						headBgColor: colourCfg.red,
						fontColor: colourCfg.white,
						content: "Are you sure you want to delete this condition? This cannot be undone.",
						onConfirm: () => {
							/// TODO: delete the condition (canvas)
							console.log("TODO: DElete condition")
						}
					});
				}
			}, {
				label: `Delete Flow ${phase.name}`,
				icon: "fad fa-trash",
				onClick: () => {
					openConfirm({
						title: `Delete Flow ${phase.name}?`,
						confirmLabel: "Delete",
						headBgColor: colourCfg.red,
						fontColor: colourCfg.white,
						content: "Are you sure you want to delete this flow? This action is not reversible and all the nodes " +
							"within the flow will be lost.",
						onConfirm: () => {
							updateCanvas({
								namespace: canvas.namespace,
								playgroundId: canvas.playground_id,
								canvasId: canvas.canvas_id,
								model: deleteCanvasPhase(dashboard, canvas.canvas_id, phase.id)
							});
						}
					});
				}
			}],
			eventY: e.clientY,
			eventX: e.clientX,
			itemActiveColor: colourCfg.purple,
			itemActiveFontColor: colourCfg.white
		});
	};
};
